const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const createPayment = async (leadId, paymentData) => {
    console.log("Отправка данных платежа:", paymentData);
    const token = localStorage.getItem('token');

    if (!token) {
        console.error('[createPayment] Ошибка: Токен авторизации не найден.');
        // throw new Error('Токен авторизации не найден.');
    }

    try {
        const response = await fetch(
            `${API_BASE_URL}/admin/lead/leads/${leadId}/payments`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(paymentData),
            }
        );

        if (!response.ok) {
            const errorData = await response.json();
            console.error('Ошибка при создании платежа:', errorData);
            throw errorData;
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Ошибка при запросе на создание платежа:', error);
        throw error;
    }
};